module.exports = __webpack_public_path__ + "static/media/game-pointadd.d7dd8459.png";